// src/pages/AuthCallback.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function safeDecodeJwt(token) {
  try {
    const base64Url = token.split(".")[1] || "";
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const json = decodeURIComponent(
      Array.prototype.map
        .call(
          atob(padded),
          (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2),
        )
        .join(""),
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

function AuthCallback() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) return;

    try {
      localStorage.setItem("token", token);

      const payload = safeDecodeJwt(token);
      if (!payload || !payload.user) throw new Error("Invalid token payload");

      localStorage.setItem("user", JSON.stringify(payload.user));
      console.log(payload);

      // is_onboarding === true => sudah pernah register => langsung ke HOME
      // false => paksa isi profil => ke edit dengan flag isOnboarding=true
      if (payload.user.is_onboarding) {
        const redirectUrl = localStorage.getItem("redirect_url");
        if (redirectUrl) {
          localStorage.removeItem("redirect_url");
          window.location.replace(redirectUrl);
        } else {
          window.location.replace("/");
        }
      } else {
        const username = payload.user.username || "me";
        const redirectUrl = localStorage.getItem("redirect_url");
        if (redirectUrl) {
          localStorage.removeItem("redirect_url");
          window.location.replace(redirectUrl);
        } else {
          window.location.replace(
            `/dashboard/profile/${username}/edit?isOnboarding=true`,
          );
        }
      }
    } catch (error) {
      console.error("Token decoding error:", error);
      // window.location.replace("/login");
    }
  }, [location]);

  return <p>Logging you in...</p>;
}

export default AuthCallback;
